import { init } from '@sentry/remix';
import { RemixBrowser } from '@remix-run/react';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { initPostHog } from './services/postHog-client';

init({
    dsn: 'https://30db7f11c733e56fa3fe30561dce36ec@o4506400115523584.ingest.us.sentry.io/4509825631846400',
    enableLogs: true,
});

initPostHog();

startTransition(() => {
    hydrateRoot(
        document,
        <StrictMode>
            <RemixBrowser />
        </StrictMode>,
    );
});
